/* The Mint Workshop — anchor scrolling.
   A sticky header means a browser's default jump lands the target underneath
   it. This offsets by the header's real measured height, handles links that
   arrive from another page, and respects reduced motion. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* What sits above the target depends on which bars are pinned at that
     moment — the header, the announcement bar, the docked CTA. Rather than add
     up heights and hope, measure whatever is actually fixed or sticky at the
     top of the viewport. */
  function topChrome() {
    var lowest = 0;
    document.querySelectorAll('.mw-hdr, .mw-announce, [data-mw-stickycta].is-on').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      if (cs.display === 'none') return;
      var b = el.getBoundingClientRect();
      if (b.top <= 4 && b.bottom > lowest) lowest = b.bottom;
    });
    return lowest;
  }

  function headerOffset() {
    return topChrome() + 14;
  }

  function goTo(el, smooth) {
    if (!el) return;
    var y = window.pageYOffset + el.getBoundingClientRect().top - headerOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: (smooth && !reduced) ? 'smooth' : 'auto' });

    /* Correct once the scroll has settled. The chrome measured before moving
       is not always the chrome that ends up pinned — an announcement bar may
       have scrolled away, or the docked CTA may have appeared. */
    var tries = 0;
    (function settle() {
      if (++tries > 14) return;
      requestAnimationFrame(function () {
        setTimeout(function () {
          var gap = el.getBoundingClientRect().top - headerOffset();
          if (Math.abs(gap) > 3) {
            window.scrollBy({ top: gap, behavior: 'auto' });
            settle();
          }
        }, 60);
      });
    })();
  }

  function target(hash) {
    if (!hash || hash === '#') return null;
    try { return document.querySelector(hash); } catch (e) { return null; }
  }

  // links within this page
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var hash = href.slice(href.indexOf('#'));
    var path = href.split('#')[0];

    // only intercept when the link points at this same page
    var samePage = !path || path === window.location.pathname ||
                   path === '/' && window.location.pathname === '/';
    if (!samePage) return;

    var el = target(hash);
    if (!el) return;

    e.preventDefault();
    goTo(el, true);
    history.replaceState(null, '', hash);

    // a drawer or modal covering the target should get out of the way
    var drawer = document.querySelector('[data-mw-drawer].is-open');
    if (drawer) {
      var close = drawer.querySelector('[data-mw-drawer-close]');
      if (close) close.click();
    }
  });

  // arriving from another page with a hash: wait for layout, then offset
  if (window.location.hash) {
    var settle = function () {
      var el = target(window.location.hash);
      if (el) goTo(el, false);
    };
    window.addEventListener('load', function () {
      settle();
      setTimeout(settle, 260);   // again once images have taken their space
    });
  }
})();

/* Tap-to-compare for the feature review, since hover does not exist on touch. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var pair = e.target.closest('[data-mw-freview]');
    if (!pair) return;
    pair.classList.toggle('is-showing');
  });
})();
